import {
  IonItem,
  IonLabel,
  IonNote,
  IonToggle
} from '@ionic/react';
import { Message } from '../data/messages';
import './MessageListItem.css';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { decremented, incremented, calculateroute } from '../counterSlice';
import { useRef } from 'react';

interface MessageListItemProps {
  message: any;
}

const MessageListItem: React.FC<MessageListItemProps> = ({ message }) => {
  const dispatch = useDispatch()
  const toggleCompany = async (company: any, i: any) => {
    i.stopPropagation()
    if (i.currentTarget.checked) {
      dispatch(incremented(company))

    } else {
      dispatch(decremented(company))

    }
    dispatch(calculateroute())
  }
  const itemRef = useRef<HTMLIonToggleElement>(null)
  return (
    <IonItem detail={false} onClick={()=>itemRef.current?.click()}>
      {/* routerLink={`/message/${message.id}`} */}

      {/* <br/> */}
      {/* <div slot="start" className="dot dot-unread"></div> */}
      <IonLabel className="ion-text-wrap">
        <h2>
          {message["Company Name"]}


        </h2>
        <h3>{message["Address 1"]}, {message["City"]}, {message["State"]}, {message["Zip"]}</h3>
       

        <p>
          {message["Company Description"]}
          {/* Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. */}
        </p>
        {message["Website"]}

      </IonLabel>
      <span slot='end' className="date">
    {/* end */}
          <IonNote>
            <IonToggle ref={itemRef} onClick={(i: any) => toggleCompany(message, i)} />
          </IonNote>
        </span>
    </IonItem>
  );
};

export default MessageListItem;
